(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aim-information-modals"] && !Shopify.designMode) return;
  try {
    if (!window.AimProductModalsReady) {
    window.AimProductModalsReady = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const openButton = event.target.closest('[data-apm-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.dataset.apmOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }
      const closeButton = event.target.closest('[data-apm-close]');
      if (closeButton) closeButton.closest('dialog')?.close();
      const dialog = event.target.closest('dialog.apm-dialog');
      if (dialog && event.target === dialog) dialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aim-ships-by"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aim-ships-by')) {
    customElements.define('aim-ships-by', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.updateDate();
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          if (event.target.closest('[data-asb-open]')) {
            if (!dialog.open) dialog.showModal();
          } else if (event.target.closest('[data-asb-close]')) {
            dialog.close();
          } else if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() { this.controller?.abort(); }

      // Recalculate in the browser so a cached page never shows a stale date
      updateDate() {
        const el = this.querySelector('.asb-date');
        if (!el) return;
        try {
          const tz = this.dataset.timezone || 'Europe/London';
          const parts = Object.fromEntries(
            new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
              .formatToParts(new Date())
              .map((p) => [p.type, p.value])
          );
          const date = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
          const hour = +parts.hour;
          const skipWeekends = this.dataset.skipWeekends === 'true';
          const cutoff = parseInt(this.dataset.cutoff, 10);
          const holidays = (this.dataset.holidays || '').split(/[\s,]+/).filter(Boolean);
          const isDispatchDay = (d) => {
            const dow = d.getUTCDay();
            if (skipWeekends && (dow === 0 || dow === 6)) return false;
            return !holidays.includes(d.toISOString().slice(0, 10));
          };

          let days = parseInt(this.dataset.days, 10) || 0;
          if (isDispatchDay(date) && cutoff < 24 && hour >= cutoff) days += 1;
          let guard = 0;
          while (days > 0 && guard < 60) {
            date.setUTCDate(date.getUTCDate() + 1);
            if (isDispatchDay(date)) days -= 1;
            guard += 1;
          }

          const long = this.dataset.format === 'long';
          const options = { weekday: long ? 'long' : 'short', day: 'numeric', month: long ? 'long' : 'short', timeZone: 'UTC' };
          let formatter;
          try { formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en-GB', options); }
          catch { formatter = new Intl.DateTimeFormat('en-GB', options); }

          el.textContent = formatter.format(date).replace(',', '');
          el.setAttribute('datetime', date.toISOString().slice(0, 10));
        } catch (e) {
          // Keep the server-rendered fallback
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lens-polarization-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aim-lens-guide')) {
    customElements.define('aim-lens-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;

          const dialog = this.querySelector('dialog');
          if (!dialog) return;

          if (event.target.closest('[data-aim-guide-open]')) {
            if (!dialog.open) dialog.showModal();
          } else if (event.target.closest('[data-aim-guide-close]')) {
            dialog.close();
          } else if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();

            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {
              dialog.close();
            }
          }
        }, {
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        this.controller?.abort();

        const dialog = this.querySelector('dialog[open]');
        if (dialog) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["location-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aim-location-delivery')) {
    customElements.define('aim-location-delivery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          if (event.target.closest('[data-ald-open]')) {
            if (!dialog.open) dialog.showModal();
          } else if (event.target.closest('[data-ald-close]')) {
            dialog.close();
          } else if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ultimate-sibling-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aim-sibling-picker')) {
  customElements.define('aim-sibling-picker', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.list = this.querySelector('[data-list]');
      if (!this.list) return;
      this.items = [...this.list.querySelectorAll('.asp-item')];
      this.current = this.items.find(item => item.querySelector('[aria-current="page"]'));
      this.toggle = this.querySelector('[data-expand]');
      this.switchButton = this.querySelector('[data-switch]');
      this.nameTarget = this.querySelector('[data-current-name]');
      this.currentName = this.current?.querySelector('.asp-card')?.dataset.name || this.nameTarget?.textContent?.trim() || '';
      this.expanded = false;
      this.allowHover = matchMedia('(hover: hover) and (pointer: fine)');
      this.mobileQuery = matchMedia('(max-width: 749px)');
      const signal = this.controller.signal;
      this.mobileQuery.addEventListener('change', () => this.update(), { signal });
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        if (this.suppressClick && event.detail > 0 && event.target.closest('.asp-card')) {
          event.preventDefault(); event.stopPropagation(); this.suppressClick = false; return;
        }
        if (event.target.closest('[data-switch]')) {
          this.setView(this.dataset.view === 'swatch' ? 'lifestyle' : 'swatch', true);
        } else if (event.target.closest('[data-expand]')) {
          this.expanded = !this.expanded; this.update();
        }
      }, { signal, capture: true });
      this.addEventListener('keydown', event => this.onKeydown(event), { signal });
      this.addEventListener('pointerover', event => {
        if (this.allowHover.matches) this.showName(event.target.closest?.('.asp-card'));
      }, { signal });
      this.addEventListener('pointerout', event => {
        const card = event.target.closest?.('.asp-card');
        if (card && !card.contains(event.relatedTarget)) this.hideName();
      }, { signal });
      this.addEventListener('focusin', event => this.showName(event.target.closest?.('.asp-card')), { signal });
      this.addEventListener('focusout', () => this.hideName(), { signal });
      this.list.addEventListener('scroll', () => this.hideName(), { signal, passive: true });
      this.list.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.list.addEventListener('pointerdown', event => {
        this.suppressClick = false;
        if (this.dataset.layout !== 'swipe' || event.pointerType !== 'mouse' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.list.scrollLeft, active: false };
      }, { signal });
      this.list.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        if (!event.buttons) { this.endDrag(); return; }
        const delta = event.clientX - this.drag.x;
        if (!this.drag.active && Math.abs(delta) > 6) {
          this.drag.active = true; this.list.setPointerCapture(event.pointerId); this.list.classList.add('is-dragging');
        }
        if (this.drag.active) { event.preventDefault(); this.suppressClick = true; this.hideName(); this.list.scrollLeft = this.drag.left - delta; }
      }, { signal });
      for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) this.list.addEventListener(type, () => this.endDrag(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this);
      let view = this.dataset.view;
      if (this.switchButton && this.dataset.editor !== 'true') {
        try { view = sessionStorage.getItem('aim-sibling-clean-view') || view; } catch {}
      }
      this.setView(view, false);
      if (this.switchButton) this.switchButton.hidden = false;
      const params = new URL(location.href).searchParams;
      for (const link of this.list.querySelectorAll('a')) {
        const url = new URL(link.getAttribute('href'), location.origin);
        for (const name of ['preview_theme_id', '_ab', '_fd', '_sc']) if (params.has(name)) url.searchParams.set(name, params.get(name));
        link.href = url.pathname + url.search + url.hash;
      }
    }
    setView(view, remember) {
      this.dataset.view = view === 'lifestyle' ? 'lifestyle' : 'swatch';
      if (this.switchButton) this.switchButton.querySelector('span').textContent = this.dataset.view === 'swatch' ? this.dataset.imagesLabel : this.dataset.swatchesLabel;
      if (remember && this.dataset.editor !== 'true') {
        try {
          sessionStorage.setItem('aim-sibling-clean-view', this.dataset.view);
          document.documentElement.dataset.aimSiblingView = this.dataset.view;
        } catch {}
      }
      this.update(); this.reveal(this.current);
    }
    update() {
      if (!this.list) return;
      this.hideName();
      this.items.forEach(item => { item.hidden = false; });
      const width = this.list.clientWidth;
      if (!width) return;
      const styles = getComputedStyle(this);
      const columns = Math.max(1, parseInt(styles.getPropertyValue('--asp-count'), 10) || 1);
      const requestedGap = parseFloat(styles.getPropertyValue('--asp-requested-gap')) || 0;
      const gap = Math.min(requestedGap, Math.max(0, (width - columns * 16) / Math.max(1, columns - 1)));
      this.list.style.setProperty('--asp-gap', `${gap}px`);
      this.setAttribute('data-ready', '');
      if (this.dataset.layout !== 'dropdown') {
        this.toggle.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.updateImageSizes();
        return;
      }
      const hasMore = this.items.length > columns;
      const shown = this.items.slice(0, columns);
      if (this.current && !shown.includes(this.current)) shown[shown.length - 1] = this.current;
      const active = document.activeElement;
      this.items.forEach(item => {
        item.hidden = hasMore && !this.expanded && !shown.includes(item);
        if (item.hidden && item.contains(active)) this.toggle.focus({ preventScroll: true });
      });
      this.toggle.hidden = !hasMore;
      this.toggle.setAttribute('aria-expanded', String(this.expanded && hasMore));
      if (!hasMore && active === this.toggle) this.current?.querySelector('a')?.focus({ preventScroll: true });
      this.updateImageSizes();
    }
    updateImageSizes() {
      const selector = this.dataset.view === 'swatch' ? '.asp-visual--swatch' : '.asp-visual--lifestyle';
      for (const item of this.items) {
        if (item.hidden) continue;
        const img = item.querySelector(`${selector} img[srcset]`);
        if (!img) continue;
        const width = Math.ceil(img.getBoundingClientRect().width);
        if (width) img.sizes = `${width}px`;
      }
    }
    showName(card) {
      if (!card || this.dataset.names !== 'hover' || this.drag?.active || !this.nameTarget) return;

      const nextName = card.dataset.name?.trim();
      if (!nextName || nextName === this.previewName) return;

      this.previewName = nextName;
      this.setHeaderName(nextName);
    }

    hideName() {
      this.previewName = '';
      this.setHeaderName(this.currentName);
    }

    setHeaderName(name) {
      if (!this.nameTarget || !name || this.nameTarget.textContent === name) return;

      cancelAnimationFrame(this.nameFrame);
      this.nameTarget.classList.add('is-updating');

      this.nameFrame = requestAnimationFrame(() => {
        this.nameTarget.textContent = name;
        this.nameTarget.classList.remove('is-updating');
      });
    }
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.hideName();
        if (this.expanded) { event.preventDefault(); this.expanded = false; this.update(); this.toggle.focus({ preventScroll: true }); }
        return;
      }
      const card = event.target.closest?.('.asp-card');
      if (!card || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const visible = this.items.filter(item => !item.hidden);
      let index = visible.indexOf(card.closest('.asp-item'));
      const rtl = getComputedStyle(this).direction === 'rtl';
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = visible.length - 1;
      else index += (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
      const item = visible[Math.max(0, Math.min(visible.length - 1, index))];
      item?.querySelector('a')?.focus({ preventScroll: true }); this.reveal(item);
    }
    reveal(item) {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        if (!item || this.dataset.layout !== 'swipe') return;
        const list = this.list.getBoundingClientRect();
        const card = item.getBoundingClientRect();
        const left = card.left < list.left ? card.left - list.left : card.right > list.right ? card.right - list.right : 0;
        this.list.scrollBy({ left, behavior: 'auto' });
      });
    }
    endDrag() {
      if (!this.drag) return;
      const id = this.drag.id; this.drag = null;
      this.list.classList.remove('is-dragging');
      if (this.list.hasPointerCapture(id)) this.list.releasePointerCapture(id);
    }
    cleanup() { this.endDrag(); this.hideName(); this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame); cancelAnimationFrame(this.nameFrame); }
    disconnectedCallback() { this.cleanup(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
